import { addSideEffects } from '@poa/state';
import {fetchById} from './shared-links.actions';


addSideEffects(fetchById, async (payload, { actions, env, router }) => {
  try {
    const data = await env.api.sharedLinks.fetchById(payload.id);

    if (data.data) {
      actions.shareLinksActions.fetchByIdSuccess(data.data);
    } else {
      actions.shareLinksActions.fetchByIdFailed();
    }
    
  } catch (e) {
    console.error(e);
    actions.shareLinksActions.fetchByIdFailed();
    throw e;
  }
});
